import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {BaseModel} from "../models/BaseModel";
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiConfig.uri+ '/api/user'; // Replace with your API endpoint

  constructor(private http: HttpClient) { }

  getUser(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/info`);
  }

  updateUser(userData: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/update`, userData);
  }

  verify(code: string): Observable<BaseModel<any>>{
    return this.http.get<any>(`${this.apiUrl}/verify?code=${code}`);
  }

  verifyWithContactId(code: string, contactId : string): Observable<BaseModel<any>>{
    return this.http.get<any>(`${this.apiUrl}/contactVerify/${contactId}?code=${code}`);
  }

  /**
   * Does nothing on the server. Its only job is to give PortalAccessLockMiddleware a chance to
   * answer 401 USER_DEACTIVATED, so the portal can find out whether a just-signed-in account is
   * still allowed in before it decides which page to open.
   */
  portalAccess(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/portal-access`);
  }

  lock(): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/lock`, {});
  }
}
